import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { Text, VStack } from "native-base";
import { MetricType, forHumans } from "@madmedical/medical";
import { useTranslation } from "@madmedical/i18n";
import PressableLink from "../atoms/PressableLink";
import { thumbnailRoot, thumbnailUnit } from "./useStyles";
const EmptyDashboardWidget = ({ metricType }) => {
    const clickableMetricTypes = [
        MetricType.BloodSugar,
        MetricType.BloodPressure,
        MetricType.BloodOxygen,
        MetricType.BodyTemperature,
        MetricType.BodyWeight,
    ];
    const { t } = useTranslation();
    const content = (_jsxs(_Fragment, { children: [_jsx(Text, Object.assign({ fontSize: "sm", fontWeight: "medium", color: "black" }, { children: t(`measures:${forHumans(metricType)}`) })), _jsx(Text, Object.assign({ style: thumbnailUnit }, { children: t("measures:noData") }))] }));
    return (_jsx(VStack, Object.assign({ style: thumbnailRoot }, { children: clickableMetricTypes.includes(metricType) ? (_jsx(PressableLink, Object.assign({ route: "measurements", params: { metricType: metricType }, flex: 1 }, { children: content }))) : (content) })));
};
export default EmptyDashboardWidget;
